/** Retain native pixels; the separate vision-chat thumbnail is never an input. */
export async function readImageReference(file, { role = 'reference', enabled = true } = {}) {
  let blob = file;
  let width;
  let height;
  const isHeic = /image\/hei[cf]/i.test(file.type) || /\.hei[cf]$/i.test(file.name || '');
  if (isHeic) {
    const module = await import('heic-decode');
    const decode = module.default || module;
    const decoded = await decode({ buffer: new Uint8Array(await file.arrayBuffer()) });
    width = decoded.width;
    height = decoded.height;
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    canvas.getContext('2d').putImageData(new ImageData(decoded.data, width, height), 0, 0);
    blob = await new Promise((resolve, reject) => canvas.toBlob((value) => value
      ? resolve(value) : reject(new Error('Unable to convert this HEIC image.')), 'image/png'));
  } else {
    const url = URL.createObjectURL(file);
    try {
      const image = new Image();
      image.src = url;
      await image.decode();
      width = image.naturalWidth;
      height = image.naturalHeight;
    } finally {
      URL.revokeObjectURL(url);
    }
  }
  return {
    id: crypto.randomUUID(), blob, name: file.name || 'Source image',
    mimeType: blob.type, width, height, role, enabled,
    ...(isHeic && { originalBlob: file })
  };
}
